import { useState, useEffect } from "react";
import { getAdminReview } from "../../../shared/api/reviews.services";

export const useFetchReview = (reviewId) => {
  const [review, setReview] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isCreateMode, setIsCreateMode] = useState(false);

  useEffect(() => {
    const fetchReview = async () => {
      try {
        setIsLoading(true);
        
        if (!reviewId || reviewId === "create") {
          setIsCreateMode(true);
          setReview(null);
          setError(null);
          return;
        }

        const data = await getAdminReview(reviewId);
        if (data) {
          setReview(data);
          setIsCreateMode(false);
        } else {
          setError("Не удалось загрузить отзыв");
        }
      } catch (err) {
        setError(err.message || "Ошибка загрузки");
      } finally {
        setIsLoading(false);
      }
    };

    fetchReview();
  }, [reviewId]);

  return { review, isLoading, error, isCreateMode };
};
